import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DefaultLayout from "../../layout/DefaultLayout";
import Loadings from "../../components/Loadings/Loadings";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { HiChevronUp, HiChevronDown } from "react-icons/hi";
import useHelmet from "../../components/hooks/useHelmet";
import { AiOutlineSearch } from "react-icons/ai";
import { BiSort } from "react-icons/bi";

import Prequa_Desc_Modal from "../../components/Modal/Descriptions/Prequa_Desc_Modal";
import { useSelector } from "react-redux";
import Prequa_Office_Modal from "../../components/Modal/Descriptions/Prequa_Office_Modal";
import { Autocomplete, TextField } from "@mui/material";
import fetchUtils from 'utils/fetchData';
import stringUtilities from "utils/stringUtilities";

export default function HiredApplicants() {
    const cookies = document.cookie.split(";").reduce((prev, curr) => {
        const [name, value] = curr.trim().split("=");
        prev[name] = value;
        return prev;
    }, {});
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [rowCount, setRowCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(
        cookies.PrequaTablePage ? parseInt(cookies.PrequaTablePage) : 1
    );
    const [rowsPerPage, setRowsPerPage] = useState(50);

    const [searchedJobTitle, setSearchedJobTitle] = useState("");
    const [searchedPlantillaNum, setSearchedPlantillaNum] = useState("");
    const [searched, setSearched] = useState("");
    const [searchedJobDescription, setSearchedJobDescription] = useState("");
    const [searchedJobOffice, setSearchedJobOffice] = useState("");
    const [searchOpen, setSearchOpen] = useState(false);

    const view = 'archived';

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [batchNumbers, setBatchNumbers] = useState([]);
    const [selectedBatchNumber, setSelectedBatchNumber] = useState();

    //Sorting
    const [sortOrder, setSortOrder] = useState("asc");
    const [sortKey, setSortKey] = useState("");
    const [defaultData, setDefaultData] = useState();
    const [selected, setSelected] = useState(false);
    const [modalIsOpenSchedule, setModalIsOpenSchedule] = useState(false);

    const [header, setHeader] = useState("");
    const [desc, setDesc] = useState("");
    const [desc2, setDesc2] = useState("");

    useHelmet("Prequalification Table - HRIS");

    //Sorting function

    const jobPositions = `${window.globalConfig.BASE_URL2}/api/JobPositions`;

    const openModal = (description) => {
        setDesc(description);
        setIsModalOpen(true);
    };
    const openModal2 = (description) => {
        setDesc2(description);
        setIsModalOpen2(true);
    };

    const closeModal = () => {
        setDesc("");
        setDesc2("");
        setIsModalOpen(false);
        setIsModalOpen2(false);
    };

    useEffect(() => {
        setCurrentPage(1);
        setRowCount(
            newData?.filter(
                (item) =>
                    item.name
                        ?.toLowerCase()
                        .includes(
                            searchedJobTitle?.toLocaleLowerCase()
                                ? searchedJobTitle?.toLocaleLowerCase()
                                : searched
                        ) &&
                    item.description
                        ?.toLowerCase()
                        .includes(
                            searchedJobDescription?.toLocaleLowerCase()
                                ? searchedJobDescription?.toLocaleLowerCase()
                                : searched
                        ) &&
                    (view === "on-going"
                        ? !item.archivedByID || item.archivedByID === null
                        : item.archivedByID && item.archivedByID !== null)
            ).length
        );
    }, [view, searchedJobTitle, searchedJobDescription]);

    const navigate = useNavigate();
    useEffect(() => {
        const handleBeforeUnload = () => {
            sessionStorage.removeItem("PreQualificationTable");
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        if (sessionStorage.getItem("PreQualificationTable")) {
            setData(JSON.parse(sessionStorage.getItem("PreQualificationTable")));
            setIsLoading(false);
            const counter = JSON.parse(
                sessionStorage.getItem("PreQualificationTable")
            );
            setRowCount(
                counter.rows.filter(
                    (item) =>
                        item.name
                            ?.toLowerCase()
                            .includes(
                                searchedJobTitle?.toLocaleLowerCase()
                                    ? searchedJobTitle?.toLocaleLowerCase()
                                    : searched
                            ) &&
                        item.description
                            ?.toLowerCase()
                            .includes(
                                searchedJobDescription?.toLocaleLowerCase()
                                    ? searchedJobDescription?.toLocaleLowerCase()
                                    : searched
                            ) &&
                        (view === "on-going"
                            ? !item.archivedByID || item.archivedByID === null
                            : item.archivedByID && item.archivedByID !== null)
                ).length
            );
        } else {
            fetchData();
        } //Call the fetch function
    }, [selectedBatchNumber]);
    const fetchData = async () => {
        try {
            const response = await fetch(`${jobPositions}/Get`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: null,
                    showArchived: true,
                    CurrentUserAsDepartmentHead: true,
                    batchNumber: selectedBatchNumber,
                    HideUnarchived: true
                }),
            });

            if (!response.ok) {
                throw new Error("Error fetching data");
            }
            const jsonData = await response.json();
            setData(jsonData);
            setRowCount(
                jsonData.rows.filter(
                    (item) =>
                        item.name
                            ?.toLowerCase()
                            .includes(
                                searchedJobTitle?.toLocaleLowerCase()
                                    ? searchedJobTitle?.toLocaleLowerCase()
                                    : searched
                            ) &&
                        item.description
                            ?.toLowerCase()
                            .includes(
                                searchedJobDescription?.toLocaleLowerCase()
                                    ? searchedJobDescription?.toLocaleLowerCase()
                                    : searched
                            ) &&
                        (view === "on-going"
                            ? !item.archivedByID || item.archivedByID === null
                            : item.archivedByID && item.archivedByID !== null)
                ).length
            );
            //sessionStorage.setItem("PreQualificationTable", JSON.stringify(jsonData));

            var pResponse = await fetchUtils.Post('/api/JobPositions/GetUniqueBatchNumbers', {});
            if (pResponse.length == 0 || stringUtilities.CStr2(pResponse[0]).trim() != '')
                pResponse.unshift('');
            setBatchNumbers(pResponse);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleRowsPerPage = (e) => {
        setRowsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    //const handlePageChange = (e) => {
    //  setCurrentPage(Number(e.target.value));
    //};

    const handleNextPage = () => {
        const lastPage = Math.ceil(rowCount / rowsPerPage);
        if (currentPage < lastPage) {
            document.cookie = `PrequaTablePage=${currentPage + 1
                }; expires=0; path=/;`;
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    const handleBackPage = () => {
        if (currentPage > 1) {
            document.cookie = `PrequaTablePage=${currentPage - 1
                }; expires=0; path=/;`;
            setCurrentPage((prevPage) => prevPage - 1);
        }
    };
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const toggleSortOrder = (key) => {
        if (key !== sortKey) {
            sortData(key, "asc");
        } else if (
            key === "name" ||
            key === "postingDate" ||
            key === "applicationDeadline"
        ) {
            if (sortOrder === "asc") {
                sortData(key, "desc");
            } else if (sortOrder === "desc") {
                sortData(key, "null");
            } else {
                sortData(key, "asc");
            }
        } else if (key === "default") {
            setNewData([...defaultData]);
            setSortOrder(null);
        }
    };
    const sortData = (key, order) => {
        const sortedData = [...newData]?.sort((a, b) => {
            if (order === "asc") {
                if (key === "name") {
                    return a[key].localeCompare(b[key]);
                } else if (key === "postingDate") {
                    return new Date(a[key]) - new Date(b[key]);
                } else if (key === "applicationDeadline") {
                    return new Date(a[key]) - new Date(b[key]);
                }
            } else if (order === "desc") {
                if (key === "name") {
                    return b[key].localeCompare(a[key]);
                } else if (key === "postingDate") {
                    return new Date(b[key]) - new Date(a[key]);
                } else if (key === "applicationDeadline") {
                    return new Date(b[key]) - new Date(a[key]);
                }
            }
        });
        if (order === "null") {
            setNewData(defaultData);
        } else {
            setNewData(sortedData);
        }
        setSortKey(key);
        setSortOrder(order);
    };

    const updatedItems = data?.rows?.map((item, index) => ({
        ...item,
        selected,
    }));
    const [newData, setNewData] = useState(updatedItems);
    useEffect(() => {
        setNewData(updatedItems);
        setDefaultData(updatedItems);
    }, [data]);

    const toggleSelected = (id) => {
        const updateddata = newData.map((item) => {
            if (item.id === id) {
                return { ...item, selected: !item.selected };
            }
            return item;
        });
        setNewData(updateddata);
    };

    const handleCloseModal = () => {
        setModalIsOpenSchedule(false);
    };

    const userTasks = useSelector((state) => state.auth.userTasks)?.split(",");
    const [viewConsolidatedIsPresent, setViewConsolidatedIsPresent] = useState(
        userTasks?.some((item) => item === "00000000-0000-0000-0000-000000000001")
    );
    useEffect(() => {
        setViewConsolidatedIsPresent(
            userTasks?.some((item) => item === "00000000-0000-0000-0000-000000000001")
        );
    }, [userTasks]);
    return (
        <div>
            <div className="">
                {isLoading ? (
                    <Loadings />
                ) : (
                    <>
                        <section>
                            <div className="bg-white">
                                <div className="w-full ">
                                    <div className="flex items-center justify-between">
                                        <Autocomplete className="mb-1"
                                            size="small" variant="standard"
                                            options={batchNumbers}
                                            onChange={(event, newValue) => {
                                                setSelectedBatchNumber(newValue);
                                            }}
                                            renderInput={(params) => (
                                                <div ref={params.InputProps.ref}>
                                                    <input type="text" {...params.inputProps} className="inputs" placeholder="Batch No." />
                                                </div>
                                            )}
                                        />

                                        {/* <div>
                          <button
                            className="btn-edit"
                            onClick={() => setModalIsOpenSchedule(true)}
                          >
                            <h1 className="text-white">
                              Schedule for HRM-PSB Interview
                            </h1>
                          </button>
                        </div> */}
                                    </div>

                                    <div className="relative flex flex-col min-w-0 break-words w-full overflow-auto scrollbar-thin bg-white shadow-lg rounded">
                                        <div className="hidden md:block w-[150%] max-h-[70vh]">
                                            <table className="relative items-center bg-transparent table w-full border-b">
                                                <thead className="bg-primary text-white sticky top-0">
                                                    <tr>
                                                        {/* <th className="px-6  w-[6%] align-middle border border-solid  py-3 text-sm uppercase border-l-0 border-r-0 whitespace-nowrap font-normal text-left"></th> */}
                                                        <th className="px-2 w-[12.5%] align-middle border border-solid  py-3 text-sm border-l-0 border-r-0  font-normal text-center">
                                                            Plantilla Item No.
                                                        </th>
                                                        <th className="px-6 w-2/5 align-middle border border-solid  py-3 text-sm  border-l-0 border-r-0 whitespace-nowrap font-normal text-center ">
                                                            <button onClick={() => toggleSortOrder("name")}>
                                                                <h1 className="flex items-center">
                                                                    Job Title{" "}
                                                                    {sortOrder === "null" ||
                                                                        sortKey !== "name" ? (
                                                                        <span>
                                                                            <BiSort className="w-4 h-4" />
                                                                        </span>
                                                                    ) : sortOrder === "asc" &&
                                                                        sortOrder !== null ? (
                                                                        <span className="indent-1">▲</span>
                                                                    ) : (
                                                                        <span className="indent-1">▼</span>
                                                                    )}
                                                                </h1>
                                                            </button>
                                                        </th>
                                                        <th className="px-6 w-1/6 align-middle border border-solid  py-3 text-sm border-l-0 border-r-0  font-normal text-center">
                                                            Job Description
                                                        </th>
                                                        <th className="px-6 w-1/6 align-middle border border-solid  py-3 text-sm border-l-0 border-r-0  font-normal text-center">
                                                            Office
                                                        </th>
                                                        <th className="px-6 align-middle border border-solid  py-3 text-sm  border-l-0 border-r-0 font-normal text-center">
                                                            <button
                                                                onClick={() => toggleSortOrder("postingDate")}
                                                            >
                                                                <h1 className="flex items-center ">
                                                                    Date Posted
                                                                    {sortOrder === "null" ||
                                                                        sortKey !== "postingDate" ? (
                                                                        <span>
                                                                            <BiSort className="w-4 h-4" />
                                                                        </span>
                                                                    ) : sortOrder === "asc" &&
                                                                        sortOrder !== null ? (
                                                                        <span className="indent-1">▲</span>
                                                                    ) : (
                                                                        <span className="indent-1">▼</span>
                                                                    )}
                                                                </h1>
                                                            </button>
                                                        </th>
                                                        <th className="px-6 align-middle border border-solid py-3 text-sm  border-l-0 border-r-0 font-normal text-center">
                                                            <button
                                                                onClick={() =>
                                                                    toggleSortOrder("applicationDeadline")
                                                                }
                                                            >
                                                                <h1 className="flex items-center ">
                                                                    Application Deadline{" "}
                                                                    {sortOrder === "null" ||
                                                                        sortKey !== "applicationDeadline" ? (
                                                                        <span>
                                                                            <BiSort className="w-4 h-4" />
                                                                        </span>
                                                                    ) : sortOrder === "asc" &&
                                                                        sortOrder !== null ? (
                                                                        <span className="indent-1">▲</span>
                                                                    ) : (
                                                                        <span className="indent-1">▼</span>
                                                                    )}
                                                                </h1>
                                                            </button>
                                                        </th>

                                                        {view === "filled-position" ? (
                                                            <>
                                                                <th className="px-6 align-middle border border-solid py-3 text-sm uppercase border-l-0 border-r-0 whitespace-nowrap font-normal text-center">
                                                                    Date Hired
                                                                </th>
                                                            </>
                                                        ) : (
                                                            <></>
                                                        )}

                                                        <th className="px-6 align-middle border border-solid py-3 text-sm uppercase border-l-0 border-r-0 whitespace-nowrap font-normal text-center sticky right-[160px] bg-primary">
                                                            Status
                                                        </th>
                                                        <th className="w-40 px-6 align-middle border border-solid py-3 text-sm uppercase border-l-0 border-r-0 whitespace-nowrap font-normal text-center sticky right-0 bg-primary min-w-[160px]">
                                                            View
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <thead>
                                                    <tr>
                                                        {/* <th className="px-6  w-[6%] align-middle border border-solid  py-3 text-sm uppercase border-l-0 border-r-0 whitespace-nowrap font-normal text-left "></th> */}
                                                        <th className="px-2 align-middle border border-solid py-1 text-sm uppercase border-l-0 border-r font-normal text-left">
                                                            <input
                                                                type="text"
                                                                value={searchedPlantillaNum}
                                                                onChange={(e) =>
                                                                    setSearchedPlantillaNum(e.target.value)
                                                                }
                                                                className="w-full rounded-[3px] border bg-searchColor border-gray-400 px-2 text-sm focus:border-primary focus:outline-none"
                                                                placeholder="Search"
                                                            />
                                                        </th>
                                                        <th className="px-2 align-middle border border-solid py-1 text-sm uppercase border-l-0 border-r font-normal text-left ">
                                                            <input
                                                                type="text"
                                                                value={searchedJobTitle}
                                                                onChange={(e) =>
                                                                    setSearchedJobTitle(e.target.value)
                                                                }
                                                                className="w-full text-sm rounded-[3px] border bg-searchColor border-gray-400 px-2  focus:border-primary focus:outline-none"
                                                                placeholder="Search"
                                                            />
                                                        </th>
                                                        <th className="px-2 align-middle border border-solid py-1 text-sm uppercase border-l-0 border-r font-normal text-left">
                                                            <input
                                                                type="text"
                                                                value={searchedJobDescription}
                                                                onChange={(e) =>
                                                                    setSearchedJobDescription(e.target.value)
                                                                }
                                                                className="w-full rounded-[3px] border bg-searchColor border-gray-400 px-2 text-sm focus:border-primary focus:outline-none"
                                                                placeholder="Search"
                                                            />
                                                        </th>
                                                        <th className="px-2 align-middle border border-solid py-1 text-sm uppercase border-l-0 border-r font-normal text-left">
                                                            <input
                                                                type="text"
                                                                value={searchedJobOffice}
                                                                onChange={(e) =>
                                                                    setSearchedJobOffice(e.target.value)
                                                                }
                                                                className="w-full rounded-[3px] border bg-searchColor border-gray-400 px-2 text-sm focus:border-primary focus:outline-none"
                                                                placeholder="Search"
                                                            />
                                                        </th>
                                                        <th className="px-2 align-middle border border-solid  py-1 text-sm uppercase border-l-0 border-r whitespace-nowrap font-normal text-left"></th>
                                                        <th className="px-2 align-middle border border-solid  py-1 text-sm uppercase border-l-0 border-r whitespace-nowrap font-normal text-left"></th>
                                                        {view === "filled-position" ? (
                                                            <th className="px-2 align-middle border border-solid  py-1 text-sm uppercase border-l-0 border-r whitespace-nowrap font-normal text-left"></th>
                                                        ) : (
                                                            <></>
                                                        )}
                                                        <th className="px-2 align-middle border border-solid  py-1 text-sm uppercase border-l-0 border-r-0 whitespace-nowrap font-normal text-left sticky right-[163.11px] bg-white -z-1"></th>
                                                        <th className="w-40 px-2 align-middle border border-solid  py-1 text-sm uppercase border-l-0 border-r-0 whitespace-nowrap font-normal text-left sticky right-0 bg-white -z-1"></th>
                                                    </tr>
                                                </thead>

                                                {newData
                                                    ?.filter(
                                                        (item) =>
                                                            item.name
                                                                ?.toLowerCase()
                                                                .includes(
                                                                    searchedJobTitle?.toLocaleLowerCase()
                                                                        ? searchedJobTitle?.toLocaleLowerCase()
                                                                        : searched
                                                                ) &&
                                                            item.description
                                                                ?.toLowerCase()
                                                                .includes(
                                                                    searchedJobDescription?.toLocaleLowerCase()
                                                                        ? searchedJobDescription?.toLocaleLowerCase()
                                                                        : searched
                                                                ) &&
                                                            item.place
                                                                ?.toLowerCase()
                                                                .includes(
                                                                    searchedJobOffice?.toLocaleLowerCase()
                                                                        ? searchedJobOffice?.toLocaleLowerCase()
                                                                        : searched
                                                                ) &&
                                                            item.plantillaItemNum
                                                                ?.toLowerCase()
                                                                .includes(
                                                                    searchedPlantillaNum?.toLocaleLowerCase()
                                                                        ? searchedPlantillaNum?.toLocaleLowerCase()
                                                                        : searched
                                                                ) &&
                                                            (view === "on-going"
                                                                ? !item.archivedByID ||
                                                                item.archivedByID === null
                                                                : view === "archived"
                                                                    ? item.archivedByID &&
                                                                    item.archivedByID !== null &&
                                                                    (item.lastestHiredDate === null ||
                                                                        !item.lastestHiredDate)
                                                                    : view === "filled-position"
                                                                        ? item.lastestHiredDate !== null &&
                                                                        item.archivedByID &&
                                                                        item.archivedByID !== null &&
                                                                        item.lastestHiredDate
                                                                        : item.lastestHiredDate === null)
                                                    )
                                                    .slice(indexOfFirstRow, indexOfLastRow)
                                                    ?.map((item) => (
                                                        <tbody className="border-b">
                                                            <tr>
                                                                {/* <th className="border-r  ">
                                      <input
                                        type="checkbox"
                                            
                                        name="checkbox"
                                        checked={item.selected}
                                        onChange={() => toggleSelected(item.id)}
                                     />
                                    </th> */}
                                                                <th className="border-t-0 w-[12.5%] px-2 align-middle border-l-0 border-r text-sm p-2 text-left font-semibold">
                                                                    <div
                                                                        onClick={() => (
                                                                            openModal(item.plantillaItemNum),
                                                                            setHeader("Plantilla Item Number")
                                                                        )}
                                                                        className="cursor-pointer"
                                                                    >
                                                                        <h1 className="line-clamp-1">
                                                                            {item.plantillaItemNum}
                                                                        </h1>
                                                                    </div>
                                                                </th>
                                                                <th className="border-t-0 w-1/5 px-4 align-middle border-l-0 border-r text-sm p-2 text-left font-semibold">
                                                                    {item.name}
                                                                </th>
                                                                <th className="border-t-0 w-1/5 px-2 align-middle border-l-0 border-r text-sm p-2 text-left font-semibold">
                                                                    <div
                                                                        onClick={() => (
                                                                            openModal(item.description),
                                                                            setHeader("Description")
                                                                        )}
                                                                        className="cursor-pointer"
                                                                    >
                                                                        <h1 className="line-clamp-1">
                                                                            {item.description}
                                                                        </h1>
                                                                    </div>
                                                                </th>
                                                                <th className="border-t-0 w-1/5 px-2 align-middle border-l-0 border-r text-sm p-2 text-left font-semibold">
                                                                    <div
                                                                        onClick={() => (
                                                                            openModal(item.place), setHeader("Office")
                                                                        )}
                                                                        className="cursor-pointer"
                                                                    >
                                                                        <h1 className="line-clamp-1">
                                                                            {item.place}
                                                                        </h1>
                                                                    </div>
                                                                </th>
                                                                <td className="border-t-0 px-6 align-middle border-l-0 border-r text-sm  p-1 text-center whitespace-nowrap">
                                                                    {new Date(
                                                                        item.postingDate
                                                                    ).toLocaleDateString("en-US", {
                                                                        month: "2-digit",
                                                                        day: "2-digit",
                                                                        year: "numeric",
                                                                    })}
                                                                </td>
                                                                <td className="border-t-0 px-6 align-center border-l-0 border-r text-sm text-center p-1 ">
                                                                    {new Date(
                                                                        item.applicationDeadline
                                                                    ).toLocaleDateString("en-US", {
                                                                        month: "2-digit",
                                                                        day: "2-digit",
                                                                        year: "numeric",
                                                                    })}
                                                                </td>
                                                                {view === "filled-position" ? (
                                                                    <td className="border-t-0 px-6 align-center border-l-0 border-r text-sm text-center p-1 ">
                                                                        {new Date(
                                                                            item.lastestHiredDate
                                                                        ).toLocaleDateString("en-US", {
                                                                            month: "2-digit",
                                                                            day: "2-digit",
                                                                            year: "numeric",
                                                                        })}
                                                                    </td>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                                <td className="border-t-0 px-2 align-center border-l-0 border-r-0 text-sm whitespace-nowrap p-1 sticky right-[163.11px] bg-white -z-1">
                                                                    <div>
                                                                        {!item.archivedByID ||
                                                                            item.archivedByID === null ? (
                                                                            <div>
                                                                                <h1 className="btn-on w-full">
                                                                                    Ongoing
                                                                                </h1>
                                                                            </div>
                                                                        ) : item.lastestHiredDate ? (
                                                                            <div className="btn-filled">
                                                                                <h1 className="">Position Filled</h1>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="py-1">
                                                                                <h1 className="btn-closed">Closed</h1>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td className="w-40 border-t-0 px-6 align-center border-l-0 border-r-0 text-sm  p-1 sticky right-0 bg-white">
                                                                    <div className="flex items-center md:justify-center">
                                                                        <div className="flex justify-center ">
                                                                            <button
                                                                                className={`${"whitespace-nowrap text-white text-sm"}`}
                                                                                onClick={() =>
                                                                                    navigate(
                                                                                        `/hired-applicant/${item.id}`
                                                                                    )
                                                                                }
                                                                            >
                                                                                <div
                                                                                    className={`${

                                                                                        // ((view === "filled-position" ||
                                                                                        //   view === "archived") &&
                                                                                        //   !userTasks?.some(
                                                                                        //     (item) =>
                                                                                        //       item ===
                                                                                        //       "00000000-0000-0000-0000-000000000004"
                                                                                        //   ) &&
                                                                                        //   !userTasks?.some(
                                                                                        //     (item) =>
                                                                                        //       item ===
                                                                                        //       "00000000-0000-0000-0000-000000000005"
                                                                                        //   ) &&
                                                                                        //   !userTasks?.some(
                                                                                        //     (item) =>
                                                                                        //       item ===
                                                                                        //       "00000000-0000-0000-0000-000000000001"
                                                                                        //   )) ||
                                                                                        // (view === "on-going" &&
                                                                                        //   !userTasks?.some(
                                                                                        //     (item) =>
                                                                                        //       item ===
                                                                                        //       "00000000-0000-0000-0000-000000000004"
                                                                                        //   ) &&
                                                                                        //   !userTasks?.some(
                                                                                        //     (item) =>
                                                                                        //       item ===
                                                                                        //       "00000000-0000-0000-0000-000000000005"
                                                                                        //   ))
                                                                                        //</button>? "hidden"
                                                                                        "bg-green-600 hover:bg-green-800 py-1 px-5 rounded"
                                                                                        }`}
                                                                                >
                                                                                    View Applicants
                                                                                </div>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    ))}
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div className="hidden md:block">
                                    <div className="flex justify-between px-5">
                                        <div className="block md:flex md:items-center px-4  md:justify-start">
                                            <p className="mb-5 italic text-sm">
                                                Count:{" "}
                                                {
                                                    newData?.filter(
                                                        (item) =>
                                                            item.name
                                                                ?.toLowerCase()
                                                                .includes(
                                                                    searchedJobTitle?.toLocaleLowerCase()
                                                                        ? searchedJobTitle?.toLocaleLowerCase()
                                                                        : searched
                                                                ) &&
                                                            item.description
                                                                ?.toLowerCase()
                                                                .includes(
                                                                    searchedJobDescription?.toLocaleLowerCase()
                                                                        ? searchedJobDescription?.toLocaleLowerCase()
                                                                        : searched
                                                                ) &&
                                                            item.place
                                                                ?.toLowerCase()
                                                                .includes(
                                                                    searchedJobOffice?.toLocaleLowerCase()
                                                                        ? searchedJobOffice?.toLocaleLowerCase()
                                                                        : searched
                                                                ) &&
                                                            (view === "on-going"
                                                                ? !item.archivedByID ||
                                                                item.archivedByID === null
                                                                : view === "archived"
                                                                    ? item.archivedByID &&
                                                                    item.archivedByID !== null &&
                                                                    (item.lastestHiredDate === null ||
                                                                        !item.lastestHiredDate)
                                                                    : view === "filled-position"
                                                                        ? item.lastestHiredDate !== null &&
                                                                        item.archivedByID &&
                                                                        item.archivedByID !== null &&
                                                                        item.lastestHiredDate
                                                                        : item.lastestHiredDate === null)
                                                    ).length
                                                }
                                            </p>
                                        </div>
                                        <div className="block md:flex md:items-center px-4 md:justify-end">
                                            <div className="block md:flex md:items-center md:gap-4">
                                                {/* <p className="mb-5 text-sm">
                              Total:{" "}
                              {
                                newData?.filter(
                                  (item) =>
                                    (view === "on-going"
                                      ? item.archivedByID === null
                                      : (item.archivedByID &&
                                    item.archivedByID !== null)) &&
                                   //(view === "archived"
                                   //  ? (item.archivedByID &&
                                    item.archivedByID !== null)
                                   //  : item.archivedByID === null)
                                    (view === "filled-position"
                                      ? item.lastestHiredDate !== null
                                      : item.lastestHiredDate === null)
                                ).length
                              }
                            </p> */}
                                                {/* <label className="mb-5 flex items-center text-sm italic">
                              Rows Per Page:
                              <select
                                value={rowsPerPage}
                                onChange={handleRowsPerPage}
                                className="ml-2 p-1 text-sm border-none italic bg-transparent focus:outline-none focus:ring-0"
                              >
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                              </select>
                            </label> */}

                                                <div className="flex items-center justify-end mb-5 gap-5">
                                                    <button
                                                        onClick={handleBackPage}
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FiChevronLeft className="w-4 h-4" />
                                                    </button>
                                                    <button
                                                        onClick={handleNextPage}
                                                        disabled={
                                                            currentPage ===
                                                            Math.ceil(
                                                                newData?.filter(
                                                                    (item) =>
                                                                        item.name
                                                                            ?.toLowerCase()
                                                                            .includes(
                                                                                searchedJobTitle?.toLocaleLowerCase()
                                                                                    ? searchedJobTitle?.toLocaleLowerCase()
                                                                                    : searched
                                                                            ) &&
                                                                        item.description
                                                                            ?.toLowerCase()
                                                                            .includes(
                                                                                searchedJobDescription?.toLocaleLowerCase()
                                                                                    ? searchedJobDescription?.toLocaleLowerCase()
                                                                                    : searched
                                                                            ) &&
                                                                        item.place
                                                                            ?.toLowerCase()
                                                                            .includes(
                                                                                searchedJobOffice?.toLocaleLowerCase()
                                                                                    ? searchedJobOffice?.toLocaleLowerCase()
                                                                                    : searched
                                                                            ) &&
                                                                        (view === "on-going"
                                                                            ? !item.archivedByID ||
                                                                            item.archivedByID === null
                                                                            : view === "archived"
                                                                                ? item.archivedByID &&
                                                                                item.archivedByID !== null &&
                                                                                (item.lastestHiredDate === null ||
                                                                                    !item.lastestHiredDate)
                                                                                : view === "filled-position"
                                                                                    ? item.lastestHiredDate !== null &&
                                                                                    item.lastestHiredDate
                                                                                    : item.lastestHiredDate === null)
                                                                ).length / rowsPerPage
                                                            )
                                                        }
                                                    >
                                                        <FiChevronRight className="w-4 h-4" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Boxes */}
                        <section>
                            <div className="block md:hidden">
                                <div className="flex items-center justify-between px-2">
                                    <div className="flex items-center justify-start my-2 gap-5">
                                        <button
                                            onClick={() => (
                                                setSearchOpen(!searchOpen),
                                                setSearchedJobTitle(""),
                                                setSearchedJobDescription("")
                                            )}
                                        >
                                            <div className="flex items-center text-black font-semibold">
                                                <span className="mr-1">Search</span>
                                                <AiOutlineSearch className="w-4 h-4" />
                                            </div>
                                        </button>
                                    </div>
                                    <div className="flex items-center justify-end my-2 gap-5">
                                        <button
                                            onClick={handleBackPage}
                                            disabled={currentPage === 1}
                                        >
                                            <FiChevronLeft className="w-4 h-4" />
                                        </button>
                                        <button
                                            onClick={handleNextPage}
                                            disabled={
                                                currentPage === Math.ceil(rowCount / rowsPerPage)
                                            }
                                        >
                                            <FiChevronRight className="w-4 h-4" />
                                        </button>
                                    </div>
                                </div>

                                <div className={`px-2 ${searchOpen ? "block" : "hidden"}`}>
                                    <input
                                        type="text"
                                        value={searchedJobTitle}
                                        onChange={(e) => setSearchedJobTitle(e.target.value)}
                                        className="mb-2 w-full rounded-[3px] border bg-searchColor text-black border-gray-400 px-2 text-sm focus:border-primary focus:outline-none"
                                        placeholder="Search Job Title"
                                    />
                                    <input
                                        type="text"
                                        value={searchedJobDescription}
                                        onChange={(e) => setSearchedJobDescription(e.target.value)}
                                        className="mb-2 w-full rounded-[3px] border bg-searchColor text-black border-gray-400 px-2 text-sm focus:border-primary focus:outline-none"
                                        placeholder="Search Job Description"
                                    />
                                </div>

                                {newData
                                    ?.filter(
                                        (item) =>
                                            item.name
                                                ?.toLowerCase()
                                                .includes(
                                                    searchedJobTitle?.toLocaleLowerCase()
                                                        ? searchedJobTitle?.toLocaleLowerCase()
                                                        : searched
                                                ) &&
                                            item.description
                                                ?.toLowerCase()
                                                .includes(
                                                    searchedJobDescription?.toLocaleLowerCase()
                                                        ? searchedJobDescription?.toLocaleLowerCase()
                                                        : searched
                                                ) &&
                                            item.place
                                                ?.toLowerCase()
                                                .includes(
                                                    searchedJobOffice?.toLocaleLowerCase()
                                                        ? searchedJobOffice?.toLocaleLowerCase()
                                                        : searched
                                                ) &&
                                            (view === "on-going"
                                                ? !item.archivedByID || item.archivedByID === null
                                                : view === "archived"
                                                    ? item.archivedByID &&
                                                    item.archivedByID !== null &&
                                                    (item.lastestHiredDate === null ||
                                                        !item.lastestHiredDate)
                                                    : view === "filled-position"
                                                        ? item.lastestHiredDate !== null &&
                                                        item.lastestHiredDate
                                                        : item.lastestHiredDate === null)
                                    )
                                    ?.slice(indexOfFirstRow, indexOfLastRow)
                                    ?.map((item) => (
                                        <div className="block md:hidden py-2 px-3">
                                            <div className="bg-white border rounded p-2 shadow">
                                                <div>
                                                    <input
                                                        type="checkbox"
                                                        name="checkbox"
                                                        checked={item.selected}
                                                        onChange={() => toggleSelected(item.id)}
                                                    />
                                                </div>
                                                <div className="flex items-center py-1">
                                                    <h1 className="font-body font-semibold">
                                                        Plantilla Item No.:{" "}
                                                        <span className="font-body text-gray-700 text-sm font-normal">
                                                            {item.plantillaItemNum}
                                                        </span>
                                                    </h1>
                                                </div>
                                                <div className="flex items-center py-1">
                                                    <h1 className="font-body font-semibold">
                                                        Job Title:{" "}
                                                        <span className="font-body text-gray-700 text-sm font-normal">
                                                            {item.name}
                                                        </span>
                                                    </h1>
                                                </div>
                                                <div className="flex items-center py-1">
                                                    <h1 className="font-body font-semibold">
                                                        Description:{" "}
                                                        <span className="font-body text-gray-700 text-sm font-normal">
                                                            {item.description}
                                                        </span>
                                                    </h1>
                                                </div>
                                                <div className="flex items-center py-1">
                                                    <div className="flex items-center gap-5">
                                                        <h1 className="font-body font-semibold">
                                                            Date Posted:{" "}
                                                        </h1>

                                                        <div className="flex items-center sm:justify-center">
                                                            <div className="flex items-center justify-center gap-2">
                                                                {new Date(item.postingDate).toLocaleDateString(
                                                                    "en-US",
                                                                    {
                                                                        month: "2-digit",
                                                                        day: "2-digit",
                                                                        year: "numeric",
                                                                    }
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex items-center py-1">
                                                    <div className="flex items-center gap-5">
                                                        <h1 className="font-body font-semibold">
                                                            Application Deadline:{" "}
                                                        </h1>

                                                        <div className="flex items-center sm:justify-center">
                                                            <div className="flex items-center justify-center gap-2">
                                                                {new Date(
                                                                    item.applicationDeadline
                                                                ).toLocaleDateString("en-US", {
                                                                    month: "2-digit",
                                                                    day: "2-digit",
                                                                    year: "numeric",
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex items-center py-1">
                                                    <div className="flex items-center gap-5">
                                                        <h1 className="font-body font-semibold">
                                                            Status:{" "}
                                                        </h1>

                                                        <div>
                                                            {!item.archivedByID ||
                                                                item.archivedByID === null ? (
                                                                <div>
                                                                    <h1 className="btn-on">Ongoing</h1>
                                                                </div>
                                                            ) : item.lastestHiredDate ? (
                                                                <div className="py-1">
                                                                    <h1 className="btn-on">Position Filled</h1>
                                                                </div>
                                                            ) : (
                                                                <div className="py-1">
                                                                    <h1 className="btn-closed">Closed</h1>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex items-center gap-5">
                                                    <h1 className="font-body font-semibold">View: </h1>

                                                    <div className="flex items-center md:justify-center">
                                                        <div className="flex justify-center ">
                                                            <div className="bg-green-600 py-1 px-6 md:py-2 md:px-5 rounded">
                                                                <button
                                                                    className="whitespace-nowrap text-white text-sm"
                                                                    onClick={() =>
                                                                        item.lastestHiredDate &&
                                                                            viewConsolidatedIsPresent &&
                                                                            view === "filled-position"
                                                                            ? navigate(
                                                                                `/hire-applicant/${item.id}`
                                                                            )
                                                                            : navigate(
                                                                                `/stage-1:-delisting/${item.id}`
                                                                            )
                                                                    }
                                                                >
                                                                    View Applicants
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                <div className="block md:flex md:items-center px-4  md:justify-start">
                                    <p className="mb-5 italic text-sm">
                                        Count:{" "}
                                        {
                                            newData?.filter(
                                                (item) =>
                                                    item.name
                                                        ?.toLowerCase()
                                                        .includes(
                                                            searchedJobTitle?.toLocaleLowerCase()
                                                                ? searchedJobTitle?.toLocaleLowerCase()
                                                                : searched
                                                        ) &&
                                                    item.description
                                                        ?.toLowerCase()
                                                        .includes(
                                                            searchedJobDescription?.toLocaleLowerCase()
                                                                ? searchedJobDescription?.toLocaleLowerCase()
                                                                : searched
                                                        ) &&
                                                    item.place
                                                        ?.toLowerCase()
                                                        .includes(
                                                            searchedJobOffice?.toLocaleLowerCase()
                                                                ? searchedJobOffice?.toLocaleLowerCase()
                                                                : searched
                                                        ) &&
                                                    (view === "on-going"
                                                        ? !item.archivedByID || item.archivedByID === null
                                                        : view === "archived"
                                                            ? item.archivedByID &&
                                                            item.archivedByID !== null &&
                                                            (item.lastestHiredDate === null ||
                                                                !item.lastestHiredDate)
                                                            : view === "filled-position"
                                                                ? item.lastestHiredDate !== null &&
                                                                item.lastestHiredDate
                                                                : item.lastestHiredDate === null)
                                            ).length
                                        }
                                    </p>
                                </div>
                            </div>
                        </section>
                    </>
                )}
            </div>

            {/* <ScheduleModal
            newData={newData}
            setNewData={setNewData}
            modalIsOpenSchedule={modalIsOpenSchedule}
            handleCloseModal={handleCloseModal}
         /> */}

            {/* Modal */}
            {isModalOpen && (
                <>
                    <div>
                        <Prequa_Desc_Modal
                            desc={desc}
                            closeModal={closeModal}
                            header={header}
                        />
                    </div>
                </>
            )}
            {isModalOpen2 && (
                <>
                    <div>
                        <Prequa_Office_Modal desc={desc2} closeModal={closeModal} />
                    </div>
                </>
            )}
        </div>
    );
}
